import React, { createContext, useCallback, useContext, useState } from "react";

export interface ContextProps {
  isCommentsShowing: boolean;
  isAddComment: boolean;
  isTagsOpened: boolean;
  showTags: () => void;
  hideTags: () => void;
  showComments: () => void;
  hideComments: () => void;
  showAddComments: () => void;
  hideAddComments: () => void;
  isLikesOpened: boolean;
  showLikes: () => void;
  hideLikes: () => void;
}

export const SocialCardContext = createContext({
  isCommentsShowing: false,
  isAddComment: false,
  isTagsOpened: false,
  showTags: () => null,
  hideTags: () => null,
  showComments: () => null,
  hideComments: () => null,
  showAddComments: () => null,
  hideAddComments: () => null,
  isLikesOpened: false,
  showLikes: () => null,
  hideLikes: () => null,
} as ContextProps);

export const SocialCardContextProvider: React.FC = (props) => {
  const [isCommentsShowing, setIsCommentsShowing] = useState(false);
  const [isAddComment, setIsAddComment] = useState(false);
  const [isTagsOpened, setIsTagsOpened] = useState(false);
  const [isLikesOpened, setIsLikesOpened] = useState(false);

  const showComments = useCallback(() => {
    setIsCommentsShowing(true);
    setIsTagsOpened(false);
    setIsLikesOpened(false);
  }, []);
  const hideComments = useCallback(() => {
    setIsCommentsShowing(false);
  }, []);
  const showAddComments = useCallback(() => {
    setIsAddComment(true);
  }, []);
  const hideAddComments = useCallback(() => {
    setIsAddComment(false);
  }, []);
  const showTags = useCallback(() => {
    setIsTagsOpened(true);
  }, []);
  const hideTags = useCallback(() => {
    setIsTagsOpened(false);
  }, []);
  const showLikes = useCallback(() => {
    setIsLikesOpened(true);
    setIsTagsOpened(false);
  }, []);
  const hideLikes = useCallback(() => {
    setIsLikesOpened(false);
  }, []);

  return (
    <SocialCardContext.Provider
      value={{
        isCommentsShowing,
        isAddComment,
        isTagsOpened,
        showTags,
        hideTags,
        showComments,
        hideComments,
        showAddComments,
        hideAddComments,
        isLikesOpened,
        showLikes,
        hideLikes,
      }}
    >
      {props.children}
    </SocialCardContext.Provider>
  );
};

export const useSocialCardState = () => {
  const {
    isCommentsShowing,
    isAddComment,
    isTagsOpened,
    showTags,
    hideTags,
    showComments,
    hideComments,
    showAddComments,
    hideAddComments,
    isLikesOpened,
    showLikes,
    hideLikes,
  } = useContext(SocialCardContext);
  return {
    isCommentsShowing,
    isAddComment,
    isTagsOpened,
    showTags,
    hideTags,
    showComments,
    hideComments,
    showAddComments,
    hideAddComments,
    isLikesOpened,
    showLikes,
    hideLikes,
  };
};
